module.exports = __webpack_public_path__ + "static/img/subway-03.6c50a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-03.png
// module id = 148
// module chunks = 0